import Vue from 'vue'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts';
import router from './router'
// import './permission'
import store from "./store"
import axios from 'axios'
import { Message, Image } from 'element-ui'
import ElementUI from 'element-ui'
import moment from 'moment'
import TlbsMap from 'tlbs-map-vue';

import VueCompositionApi from '@vue/composition-api'
Vue.use(VueCompositionApi)
Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
Vue.prototype.$apiUrl = process.env.VUE_APP_URL
Vue.config.productionTip = false
import directive from './common/directive'
import fun from './common/fun'
import reg from './common/reg'
import Pagination from '@/components/Pagination'
import FileUpload from '@/components/FileUpload'
import EmptyList from '@/components/EmptyList'
import { getDicts } from '@/api/index'
import Print from "@/utils/print";
Vue.use(Print);
import MetaInfo from 'vue-meta-info'
// 注册 
Vue.use(MetaInfo)
// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('FileUpload', FileUpload)
Vue.component('EmptyList', EmptyList)

Vue.use(directive)
Vue.prototype.$common = fun
Vue.prototype.$reg = reg
Vue.prototype.getDicts = getDicts

Vue.prototype.msgSuccess = function(msg) {
    Message.success(msg)
}

Vue.prototype.msgError = function(msg) {
    Message.error(msg)
}
Vue.use(Image)
Vue.use(ElementUI)
Vue.use(TlbsMap);

new Vue({
    router,
    store,
    render: h => h(App),
    mounted () {
        document.dispatchEvent(new Event('render-event'))
       }
}).$mount('#app')